<template>
	<div class="content background1">
		<div class="alarm-info">
			<ul>
				<li>
					<img src="../../assets/img/map/alarm-icon.png" />
					全时段报警总次数：<span class="warning">{{
            statisticAll.allTime
          }}</span>
				</li>
				<li>
					<img src="../../assets/img/map/normal-icon.png" />
					已处理总次数：<span class="normal">{{
            statisticAll.allCompletion
          }}</span>
				</li>
				<li>
					<img src="../../assets/img/map/alarm-icon.png" />
					今日报警次数：<span class="warning">{{
            statisticAll.todayTime
          }}</span>
				</li>
				<li>
					<img src="../../assets/img/map/normal-icon.png" />
					今日已处理总次数：<span class="normal">{{
            statisticAll.todayCompletion
          }}</span>
				</li>
			</ul>
		</div>
		<div class="customer-info">
			<div class="info-list">
				<ul>
					<li v-for="item in statisticCity" :key="item.id">
						<div class="info-name">{{ item.areaName }}</div>
						<div class="info-param">
							<span>设备总数</span><span>{{ item.deviceTotal }}</span>
						</div>
						<div class="info-param">
							<span>使用中总设备数</span><span>{{ item.useCount }}</span>
						</div>
						<div class="info-param">
							<span>正常状态设备数</span><span>{{ item.normalStateCount }}</span>
						</div>
						<div class="info-param">
							<span>报警状态设备数</span><span>{{ item.alarmCount }}</span>
						</div>
						<div class="info-param">
							<span>待维护设备数</span><span>{{ item.toMaintainCount }}</span>
						</div>
						<div class="info-param">
							<span>离线设备总数</span><span>{{ item.offLineCount }}</span>
						</div>
						<div class="info-param">
							<span>探测器总数</span><span>{{ item.ttCount }}</span>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<div class="map-info">
			<div class="middle-layer">
				<baidu-map class="map" :scroll-wheel-zoom="true" :center="center" :zoom="zoom" @ready="handler">
					<bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
					<bm-marker style="background-color: #00ff00; color: #00ff00" v-for="(item, index) in mapList"
						:position="item" shape="BMAP_POINT_SHAPE_WATERDROP" :key="index" @click="clickHandler(item)"
						:icon="makeIcon(item.markerColor)">
					</bm-marker>
					<bm-info-window :position="marker" :show="show" :closeOnClick="true" style="font-size: 14px">
						<p>公司名称：{{ selectMapPoint.customerName }}</p>
						<p>详细地址：{{ selectMapPoint.address }}</p>
						<p>设备报警数：{{ selectMapPoint.alarmCount }}</p>
						<p>设备离线数：{{ selectMapPoint.offLine }}</p>
						<p>设备故障数：{{ selectMapPoint.defectCount }}</p>
						<p>控制器数量：{{ selectMapPoint.controllerCount }}</p>
						<p>探测器数量：{{ selectMapPoint.detectorCount }}</p>

						<p style="margin-top: 10px">探头位置</p>
						<template>
							<p v-for="item in selectMapPoint.probeInfos">{{ item }}</p>
						</template>

					</bm-info-window>
				</baidu-map>
			</div>
		</div>
	</div>
</template>
<script>
	import "@/assets/css/map/map.css";
	import MapJs from "@/assets/js/map/map.js";
	export default {
		name: "mapAlarm",
		data() {
			return {
				center: {
					//lng: "121.607",
					//lat: "38.96",
					lng: "121.48789",
					lat: "31.24916",
				},
				zoom: 12,
				mapList: [],
				marker: {
					//lng: 121.607,
					//lat: 38.96,
					lng: 121.48789,
					lat: 31.24916,
				},
				show: false,
				statisticAll: {
					allTime: "",
					allCompletion: "",
					todayTime: "",
					todayCompletion: "",
				},
				selectMapPoint: {
					customerName: "",
					address: "",
					offLine: "",
					alarmCount: "",
					defectCount: "",
					controllerCount: "",
					detectorCount: "",
					probeInfos: [],
				},
				areaName: "",
				statisticCity: [],
			};
		},
		watch: {
			msg: function(newVal, oldVal) {
				// TO DO
				console.log("newVal:", newVal);
				console.log("oldVal:", oldVal);
			},
		},
		methods: {
			makeIcon(r) {
				if (r == "r") {
					return {
						url: "https://www.sfrsafety.com/static/img/marker-" + r + ".gif",
						size: {
							width: 32,
							height: 32,
						},
					};
				} else {
					return {
						url: "https://www.sfrsafety.com/static/img/marker-" + r + ".png",
						size: {
							width: 32,
							height: 32,
						},
					};
				}
			},

			handler() {},
			clickHandler(e) {
				this.show = true;
				console.log("daozhel e");
				let param = {
					customerId: e.customerId
				};
				MapJs.getMapListByCustomerId(param)
					.then((response) => {
						const data = response.data;
						console.log(data);
						if (data.code == 1) {
							this.marker = {
								lng: data.data.lng,
								lat: data.data.lat,
							};
							console.log("12312:" + JSON.stringify(data.data.probeInfos));
							this.selectMapPoint = {
								customerName: data.data.customerName,
								address: data.data.address,
								offLine: data.data.offLine,
								alarmCount: data.data.alarmCount,
								defectCount: data.data.defectCount,
								controllerCount: data.data.controllerCount,
								detectorCount: data.data.detectorCount,
								probeInfos: data.data.probeInfos,
							};
							console.log("输出：" + JSON.stringify(selectMapPoint));
						}
					})
					.catch((response) => {});
			},
			getStatisticAll(item) {
				for (let a in item) {
					if (Array.isArray(item[a])) {
						item[a] = item[a][0];
					} else if (item[a] == "all") {
						item = {
							city: null,
						};
					}
				}
				MapJs.getStatisticAll(item)
					.then((response) => {
						const data = response.data;
						if (data.code == 1) {
							this.statisticAll = data.data;
						}
					})
					.catch((response) => {});
			},
			queryArea(item, lng, lat) {
				if (item == "all") {
					item = {
						city: "all",
					};
				}
				this.areaName = item;
				this.getMapList(item);
				this.getDeviceInfo(item);

				if (item.city != "all" && item.city != undefined) {
					var $this = this
					var myGeo = new BMap.Geocoder();
					myGeo.getPoint(item.city, function(point) {
						$this.center.lng = point.lng
						$this.center.lat = point.lat
						$this.zoom = 12
					}, item.city)
				} else {
					this.center.lng = lng;
					this.center.lat = lat;
				}

				this.getStatisticAll(item);
			},
			getDeviceInfo(item) {
				MapJs.getStatisticCity(item)
					.then((response) => {
						const data = response.data;
						if (data.code == 1) {
							this.statisticCity = data.data;
						}
					})
					.catch((response) => {});
			},

			getMapList(item) {
				if (item == "all") {
					item = "";
				}
				MapJs.getMapList(item)
					.then((response) => {
						const data = response.data;
						console.log(data);
						if (data.code == 1) {
							this.mapList = data.data;
						}
					})
					.catch((response) => {});
			},
		},
		created() {
			this.getStatisticAll({
				city: "all",
			});
			//this.queryArea("all", "121.607", "38.96");
			this.queryArea("all", "121.48789", "31.24916");
		},
	};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/map/map.vue